import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-h-detail__header" }
const _hoisted_2 = { class: "p-h-detail__body" }
const _hoisted_3 = { class: "p-h-detail__body__inner" }
const _hoisted_4 = { class: "p-h-detail__body__point" }
const _hoisted_5 = { class: "p-h-detail-point" }
const _hoisted_6 = {
  key: 0,
  class: "p-h-detail__point__label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PointNotation = _resolveComponent("PointNotation")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-h-detail", { 'p-h-detail--max_width': _ctx.maxWidth }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.image === false)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["p-h-detail__header__image p-h-detail__header__no-image", _ctx.roundedClassName])
          }, null, 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["p-h-detail__header__image", _ctx.roundedClassName])
      }, [
        _renderSlot(_ctx.$slots, "image", {}, undefined, true)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "header", {}, undefined, true),
        _renderSlot(_ctx.$slots, "body", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_PointNotation, {
            point: _ctx.usagePoint.point,
            "sign-is-exists": true,
            sign: _ctx.usagePoint.sign,
            "font-size": _ctx.pointStyle.fontSize,
            "icon-size": _ctx.pointStyle.iconSize
          }, null, 8, ["point", "sign", "font-size", "icon-size"]),
          _renderSlot(_ctx.$slots, "points", {}, undefined, true),
          (_ctx.$slots.label)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "label", {}, undefined, true)
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "point", {}, undefined, true)
        ])
      ])
    ])
  ], 2))
}